import React from "react";
import { PenTool } from "lucide-react";

export const AvisoGerencia = ({ rows, onAbrir }) => (
  <div className="rounded-xl border border-orange-200 bg-orange-50/70 p-4" data-testid="aviso-gerencia-panel">
    <p className="flex items-center gap-2 text-sm font-semibold text-orange-800"><PenTool className="h-4 w-4" /> {rows.length === 1 ? "1 contratación espera" : `${rows.length} contrataciones esperan`} la firma de Gerencia</p>
    <p className="text-xs text-orange-700/80">Esto es lo que falta para que la firma de Gerencia se aplique sola.</p>
    <div className="mt-3 divide-y divide-orange-100 rounded-lg border border-orange-100 bg-white">
      {rows.map((r) => (
        <div key={r.id} className="flex flex-wrap items-start justify-between gap-2 px-3 py-2" data-testid={`aviso-gerencia-item-${r.id}`}>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-slate-800">{r.nombre} <span className="text-xs font-normal text-slate-400">· {r.numero_contrato} · lleva Gerencia: {r.docs_gerencia.join(", ")}</span></p>
            {r.faltan_gerencia.length === 0
              ? <p className="text-xs text-emerald-700">Todo listo: la firma se aplicará en breve.</p>
              : <ul className="mt-0.5 list-disc pl-4 text-xs text-orange-800">{r.faltan_gerencia.map((m) => <li key={m}>{m}</li>)}</ul>}
          </div>
          <button onClick={() => onAbrir(r)} data-testid={`aviso-gerencia-abrir-${r.id}`} className="rounded-lg border border-orange-200 px-3 py-1.5 text-xs font-semibold text-orange-800 hover:bg-orange-100">Abrir</button>
        </div>
      ))}
    </div>
  </div>
);
